import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ButtonV2 } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import componentStyle from './floating-sign-up-button.style';

interface IProps {
  query: string;
  label: string;
}

export const FloatingSignUpButton = ({ query, label }: IProps) => {
  const [mounted, setMounted] = useState(false);
  const styles = componentStyle();

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted
    ? createPortal(
        <SignupLink
          style={styles.button}
          query={query}
          clickedSection="enquiryBottomButton"
          clickedLocation="supplierProfile"
          cta={label}>
          <ButtonV2>{label}</ButtonV2>
        </SignupLink>,
        document.body,
      )
    : null;
};
